import { render, staticRenderFns } from "./CreateSheetModal.vue?vue&type=template&id=aa0263b8"
import script from "./CreateSheetModal.vue?vue&type=script&lang=ts"
export * from "./CreateSheetModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports